import { ApiBase } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'
import type { Workflow } from 'types/automations'

export async function listWorkflows(
  requestParams: { signal?: AbortSignal } = {}
): Promise<Workflow[]> {
  return makeGetRequest(`${ApiBase}/calendar/workflows`, requestParams)
}
